const SupplierBankAccountsService = {
  url: `${process.env.VUE_APP_API_URL}suppliers-bank-accounts`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  create: async (data) => {
    try {
      const headers = SupplierBankAccountsService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(
        `${SupplierBankAccountsService.url}/create`,
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: SupplierBankAccountsService.headers,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  update: async (data) => {
    try {
      const headers = SupplierBankAccountsService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(
        `${SupplierBankAccountsService.url}/update`,
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: SupplierBankAccountsService.headers,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },
};

export default SupplierBankAccountsService;
